import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getCreditThunk,
  getPanelsThunk,
  getTokenThunk,
  requestOtpThunk,
  requestRegisterOtpThunk,
} from "./auth.thunk";
import {
  ApiPanelRecord,
  defaultPanel,
} from "./auth.entity";
import { SetAuthDataRequest } from "./auth.api";

export enum AuthState {
  PhoneEntrance = "PhoneEntrance",
  OtpEntrance = "OtpEntrance",
  OtpSmsEntrance = "OtpSmsEntrance",
  BaleRegister = "BaleRegister",
  Register = "Register",
  Success = "Success",
}

export interface AuthStore {
  authState: AuthState;
  phone: string;
  transactionHash: string;
  myPanel: ApiPanelRecord;
  authenticationDraft: SetAuthDataRequest;
}

export const InitialAuthState: AuthStore = {
  authState: AuthState.PhoneEntrance,
  phone: "",
  transactionHash: "",
  myPanel: defaultPanel,
  authenticationDraft: {
    full_name: "",
    shenase_melli: "",
    economic_number: "",
    land_line_phone: "",
    address: "",
    zip_code: "",
    establishment_file_id: "",
    changes_file_id: "",
    permission_file_id: "",
    national_code: "",
  },
};

const AuthSlice = createSlice({
  name: "AuthSlice",
  initialState: InitialAuthState,
  reducers: {
    setAuthState(state, action: PayloadAction<AuthState>) {
      state.authState = action.payload;
    },
    setAuthenticationDraft(state, action: PayloadAction<SetAuthDataRequest>) {
      state.authenticationDraft = {
        ...state.authenticationDraft,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestOtpThunk.fulfilled, (state, action) => {
        state.authState = AuthState.OtpEntrance;
        state.phone = action.payload.phone;
        state.transactionHash = action.payload.transactionHash || "";
      })
      .addCase(requestRegisterOtpThunk.fulfilled, (state, action) => {
        state.authState = AuthState.OtpSmsEntrance;
        state.phone = action.payload.phone;
        state.transactionHash = action.payload.transactionHash || "";
      })
      .addCase(getTokenThunk.fulfilled, (state, action) => {
        const authState = action.payload?.state;
        if (authState) {
          state.authState = authState;
        }
      })
      .addCase(getPanelsThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.myPanel = {
            ...action.payload,
          };
        }
      })
      .addCase(getCreditThunk.fulfilled, (state, action) => {
        if (action.payload) {
          state.myPanel.credit = action.payload.Credit;
          state.myPanel.credit_expire_time = action.payload.ExpireDate;
        }
      });
  },
});

export const AuthActions = AuthSlice.actions;
export const AuthReducer = AuthSlice.reducer;
